import React from 'react';


const I18NextContext = React.createContext({
    currentLanguage: null,
    changeLanguages: null,
    isRenderedRTL: null, // RTL = Right-to-Left
    translations: null,
    availableLanguages: null
});

export default I18NextContext
